<template>
  <div id="app" class="min-h-screen font-sans antialiased text-grey-darkest leading-normal border-t-8 flex flex-col overflow-hidden" :style="{borderColor: brandColor}">
    <template v-if="businessLoaded">
      <header class="pt-10 pb-8">
        <!-- <span @click="movetoRoot">Home</span> -->
        <div class="text-center" v-if="img">
          <img class="mx-auto block" :src="img" style="width:200px;"/>
        </div>
      </header>
      <main class="flex flex-grow justify-center px-4">
        <div v-if="NotAValidCompany" class="mx-auto pb-4 px-4">
          <p class="mb-3">This company could not be found.</p>
          <p class="mb-3"></p>
        </div>
        <!-- <div v-else-if="limitFlag" class="mx-auto pb-4 px-4">
          <p class="mb-3">This survey has closed.</p>
          <p class="mb-3"></p>
        </div> -->
        <transition v-else name="page-slide-horizontal" mode="out-in"  @afterEnter="afterEnter">
          <router-view :company="company" :img="img" :brand-color="brandColor"></router-view>
        </transition>
      </main>
    </template>
    <footer class="w-full bg-grey-light text-white px-4 p-1">
      <div class="container mx-auto flex justify-center">
       <button @click="$modal.show('privacy-modal')" class="text-grey-darker font-bold text-sm">Privacy</button>
      </div>
    </footer>
    <modal name="install-prompt" :pivot-y="0.1" height="auto" width="350" :adaptive="true">
      <button class="absolute pin-t pin-r p-4" @click="$modal.hide('install-prompt')"><span class="fal fa-times text-grey-darker"></span></button>
      <div class="p-4">
        <img style="max-width: 150px;" class="mx-auto block" v-if="!company" :src="img" alt="">
        <img style="max-width: 150px;" v-else class="rounded-lg mx-auto block" :src="`/static/img/icons/${company_id}/android-chrome-192x192.png`" alt="">
        <p>
          Install this application on your home screen to follow your survey results against the market’s in real time.
        </p>
        <br>
        <div>
          <p class="text-sm text-grey-darker text-center">Just tap
              <svg class="inline -mb-1" style="width:25px;fill:#1485FF;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" enable-background="new 0 0 50 50"><path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z"/><path d="M24 7h2v21h-2z"/><path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z"/></svg>
            at bottom of screen then select  <span class="font-bold">Add to Home Screen</span>.
          </p>
        </div>
      </div>
    </modal>
    <modal name="privacy-modal" :pivot-y="0.1" height="auto" width="400" :adaptive="true" :scrollable="true">
      <button class="absolute pin-t pin-r p-4" @click="$modal.hide('privacy-modal')"><span class="fal fa-times text-grey-darker"></span></button>
      <div class="p-4">
        <h2 class="mb-3 text-lg">Confidentiality</h2>
        <p class="mb-3">The information you provide will only be used by K3 Consulting Ltd for the purpose specified above. We will not disclose your information to any party outside of this process. The information you provide will be stored securely by K3 Consulting with appropriately restricted access.</p>
        <h2 class="mb-3 text-lg">Authorisation</h2>
        <ol class="mb-3">
          <li>I understand and agree that information collected is personal information and may include sensitive information as defined under The Privacy Act (1993). More information on how we collect, store and manage your personal information is outlined in our Privacy Policy, which can be found here - Privacy & Confidentiality Policy 2020</li>
          <li>I declare that the information supplied by me will be to the best of my knowledge, true, accurate and complete in all respects. I acknowledge that I will not hold K3 Consulting Ltd responsible for any omission or misstatements, which I have made in the information provided.</li>
          <li>I confirm that I give permission for the results of this survey to be released to K3 Consulting Ltd.</li>
        </ol>
        <p class="mb-3">Should you now choose to continue with the survey, please note you are authorizing us to collect, store and manage your personal information, as well as your assessment results.  If you do not wish K3 Consulting to use the results in the above manner, we advise that you should not proceed beyond this point. Please contact us for further discussion as needed.</p>
        <h2 class="mb-3 text-lg">Contact Us:</h2>
        <p class="mb-3">Should you experience any technical difficulties when completing the assessment, please contact K3 Consulting on <a href="mailto:surveys@k3.co.nz">surveys@k3.co.nz</a>.</p>
      </div>
    </modal>
  </div>
</template>

<script>
// import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import '@/assets/css/main.css'
export default {
  name: 'app',
  data () {
    return {
      businessLoaded: false,
      NotAValidCompany: false,
      limitFlag: false,
      company: '',
      company_id: '',
      departments: '',
      img: '/static/img/logo.png',
      brandColor: '#EF4A47'
    }
  },
  watch: {
    '$route': function (to) {
      if (to.name === 'survey') {
        this.verifyCompany()
      }
    }
  },
  methods: {
    // Detects if device is on iOS
    isIos () {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    },
    // Detects if device is in standalone mode
    isInStandaloneMode () {
      return ('standalone' in window.navigator) && (window.navigator.standalone)
    },
    // Emits an event to the question page that will refresh the slider component when the page has finished transitioning. Or else it breaks.
    afterEnter () {
      this.$emit('refresh-slider')
    },
    movetoRoot () {
      this.$router.push({name: 'Hello'})
    },
    generateCompanyManifest (company, routeName) {
      var myDynamicManifest = {
        'name': company.name + ' Pulse',
        'display': 'standalone',
        'orientation': 'portrait',
        'start_url': `https://survey.employeeconfidence.co.nz/#/${routeName === 'survey' ? 'survey' : 'customer'}/${company.link}`,
        'background_color': '#ffffff',
        'theme_color': '#ffffff',
        'icons': [{
          'src': `/static/img/icons/${company.id}/android-chrome-192x192.png`,
          'sizes': '192x192',
          'type': 'image/png'
        }, {
          'src': `/static/img/icons/${company.id}/android-chrome-256x256.png`,
          'sizes': '256x256',
          'type': 'image/png'
        }]
      }
      console.log('manifest object', myDynamicManifest)
      return myDynamicManifest
    },
    updateMenifest (company) {
      var manifestUrl
      // If there is no manifest, use the default manifest
      if (company === 'generic') {
        manifestUrl = `/static/manifest.json`
        document.getElementById('iconSm').setAttribute('href', '/static/img/defaultIcons/favicon-16x16.png')
        document.getElementById('iconLg').setAttribute('href', '/static/img/defaultIcons/favicon-32x32.png')
        document.getElementById('iconApple').setAttribute('href', '/static/img/defaultIcons/apple-touch-icon.png')
      } else {
        const myDynamicManifest = this.generateCompanyManifest(company, this.$route.name)
        const stringManifest = JSON.stringify(myDynamicManifest)
        const blob = new Blob([stringManifest], {type: 'application/json'})
        manifestUrl = URL.createObjectURL(blob)
        document.getElementById('iconSm').setAttribute('href', '/static/img/icons/' + company.id + '/favicon-16x16.png')
        document.getElementById('iconLg').setAttribute('href', '/static/img/icons/' + company.id + '/favicon-32x32.png')
        document.getElementById('iconApple').setAttribute('href', '/static/img/icons/' + company.id + '/apple-touch-icon.png')
        // manifestUrl = `/static/manifest-${company.id}-${this.$route.name === 'survey' ? 'company' : 'customer'}.json`
      }
      console.log(manifestUrl)
      document.querySelector('#placeholder-manifest').setAttribute('href', manifestUrl)
      // document.querySelector('link').setAttribute('href', company.logo)
      // e = document.querySelector('link[rel="apple-touch-icon"]') // .setAttribute('href', company.logo)
      // e.setAttribute('href', company.logo)
      // console.log(e)
      // e = document.querySelector('link[rel="mask-icon"]')
      // e.setAttribute('href', company.logo)
      // e = document.querySelector('meta[name="msapplication-TileImage"]')
      // e.setAttribute('href', company.logo)
    },
    verifyCompany () {
      const link = this.$route.name === 'generic' ? 'generic' : this.$route.params.link
      axios.get(`${process.env.APP_PATH}/company/${link}`)
        .then(response => {
          this.businessLoaded = true
          this.company = response.data.name
          this.company_id = response.data.id
          this.departments = response.data.departments
          this.img = response.data.logo
          if (response.data.count >= response.data.limit) {
            this.limitFlag = true
          }
          // this.limitFlag = true
          if (response.data.brand_color) this.brandColor = response.data.brand_color
          if (this.$route.params.link !== 'generic') {
            this.updateMenifest(response.data)
          }
          localStorage.setItem('company', JSON.stringify({
            name: response.data.name,
            logo: response.data.logo,
            link: response.data.link,
            departments: response.data.departments,
            limitFlag: this.limitFlag
          }))
          this.$emit('compnayUpdated')
        })
        .catch(e => {
          this.businessLoaded = true
          if (e.response.status === 404) {
            this.NotAValidCompany = true
          }
          // If there is no company, use the generic manifest
          this.updateMenifest('generic')
        })
      if (localStorage.getItem('surveySubmit')) {
        if (localStorage.getItem('surveyType') === 'customer') {
          this.$router.push(`/customerfinal/${this.$route.params.link ? this.$route.params.link : ''}`)
        } else {
          this.$router.push(`/final/${this.$route.params.link ? this.$route.params.link : ''}`)
        }
      }
    }
  },
  mounted () {
    // window.addEventListener('beforeinstallprompt', function (event) {
    //   console.log('before install prompt')
    //   event.prompt()
    // })

    // Checks if should display install popup notification:
    if (this.isIos() && !this.isInStandaloneMode()) {
      // this.setState({ showInstallMessage: true });
      this.$modal.show('install-prompt')
    }
  },
  beforeCreate () {
    const link = this.$route.name === 'generic' ? 'generic' : this.$route.params.link
    axios.get(`${process.env.APP_PATH}/company/${link}`)
      .then(response => {
        this.businessLoaded = true
        this.company = response.data.name
        this.company_id = response.data.id
        this.departments = response.data.departments
        this.img = response.data.logo
        if (response.data.count >= response.data.limit) {
          this.limitFlag = true
        }
        // this.limitFlag = true
        if (response.data.brand_color) this.brandColor = response.data.brand_color
        if (this.$route.params.link !== 'generic') {
          this.updateMenifest(response.data)
        }
        localStorage.setItem('company', JSON.stringify({
          name: response.data.name,
          logo: response.data.logo,
          link: response.data.link,
          departments: response.data.departments,
          limitFlag: this.limitFlag
        }))
        this.$emit('compnayUpdated')
      })
      .catch(e => {
        this.businessLoaded = true
        if (e.response.status === 404) {
          this.NotAValidCompany = true
        }
        // If there is no company, use the generic manifest
        this.updateMenifest('generic')
      })
    if (localStorage.getItem('surveySubmit')) {
      if (localStorage.getItem('surveyType') === 'customer') {
        this.$router.push(`/customerfinal/${this.$route.params.link ? this.$route.params.link : ''}`)
      } else {
        this.$router.push(`/final/${this.$route.params.link ? this.$route.params.link : ''}`)
      }
    }
  }
}
</script>
<style src="./assets/css/main.css" lang="css"></style>
<style>
  .font-sans {
    font-family: 'Muli', sans-serif;
  }

  .employee-confidence-slider .vue-slider-component .vue-slider-dot {
    box-shadow: none;
  }

  .employee-confidence-slider .vue-slider-component .vue-slider {
    background-color: #f1f5f8!important;
  }
  .employee-confidence-slider .vue-slider-component .vue-slider-process {
    background-color: #f1f5f8!important;
  }

  .employee-confidence-slider .vue-slider-component .vue-slider-dot.vue-slider-always .vue-slider-tooltip-wrap {
    display:flex!important;
    align-items: center;
    justify-content: center;
  }

  .employee-confidence-slider .vue-slider-component .vue-slider-tooltip-bottom.vue-slider-tooltip-wrap {
    top: 0;
    position: absolute;
    transform: translate(-50%, 0%);
    height:100%;
  }

  .employee-confidence-slider .vue-slider-component .vue-slider-tooltip-bottom.vue-slider-tooltip-wrap .vue-slider-tooltip {
    background: transparent;
    border: none;
  }

  .question-enter-active, .question-leave-active {
    transform:scale(1);
    opacity:1;
    transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .question-enter, .question-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform:scale(0.9);
  }

  /* .question-stagger-enter-active, .question-stagger-leave-active {
    transform:scale(1);
    opacity:1;
    transition: all 400ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transition-delay: 0.05s;
  }
  .question-stagger-enter, .question-stagger-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform:scale(0.8);
  } */

   .number-enter-active, .number-leave-active {
    transform:translateY(0px);
    opacity:1;
    transition: all 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
  }
  .number-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform:translateY(5px);
  }
  .number-enter /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform:translateY(-5px);
  }

  .page-slide-horizontal-enter-active, .page-slide-horizontal-leave-active {
    transition: all .4s ease;
    transform: translateX(0%)
  }

  .page-slide-horizontal-enter {
    opacity: 0;
    transform: translateX(20%)
  }

  .page-slide-horizontal-leave-to {
    opacity: 0;
    transform: translateX(-20%)
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue